import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("img", {
    src: _ctx.src,
    alt: _ctx.alt,
    style: _normalizeStyle(_ctx.logoStyle),
    class: "brand-logo"
  }, null, 12, _hoisted_1);
}